import { render } from "./optional.vue?vue&type=template&id=31fdf500&scoped=true"
import script from "./optional.vue?vue&type=script&lang=js"
export * from "./optional.vue?vue&type=script&lang=js"

import "./optional.vue?vue&type=style&index=0&id=31fdf500&scoped=true&lang=css"

import exportComponent from "D:\\Users\\User\\Documents\\_PROJECTS\\VUE.JS\\tulmash\\web_widgets\\calc_auger\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31fdf500"]])

export default __exports__